export default __webpack_public_path__ + "static/media/city_from_belvedere.f85bf704.jpg";